<script setup lang="ts">
definePageMeta({
  name: "subject",
  layout: "subject",
})

const products = useProductContentStore()

const personalization = usePersonalizationStore()

onMounted(() => {
  if (personalization.lastActiveArticle) {
    const id = personalization.lastActiveArticle.id
    const element = document.getElementById(id.toString())
    if (element && import.meta.client) {
      setTimeout(() => {
        element.scrollIntoView()
        window.scrollBy(0, -200)
      }, 100)
    }
  }
})
</script>

<template>
  <nav
    class="w-full max-w-[70rem] pb-32 pt-6 md:w-[21rem] lg:w-full xl:pt-[2.5em]"
  >
    <ul
      v-if="products.articles.length"
      id="article-cards"
      :key="0"
      class="flex flex-col gap-10"
    >
      <li
        v-for="(article, key) in products.articles.filter(a => !a.restricted)"
        :key="key"
      >
        <NuxtLink
          v-if="article.frontendHref"
          data-pendo="article-card"
          class="mx-auto flex h-[231px] w-full cursor-pointer flex-col gap-3 transition-transform duration-150 ease-linear md:w-full md:max-w-none md:hover:scale-[101%] lg:h-[500px]"
          :to="article.frontendHref"
        >
          <UPreview :article="article" />
        </NuxtLink>
      </li>
      <li
        v-for="(article, key) in products.articles.filter(a => a.restricted)"
        :key="key"
      >
        <div
          data-pendo="article-locked-card"
          class="mx-auto flex h-[231px] w-full max-w-[350px] cursor-default flex-col gap-3 transition-transform duration-150 ease-linear md:w-full md:max-w-none lg:h-[500px]"
        >
          <UPreview :article="article" />
        </div>
      </li>
    </ul>
    <USkeletonCardList v-else :key="1" />
  </nav>
</template>
